import MetricModel from "./MetricModel";
import MetricOperations from "./MetricOperations";

export default class AllPinsModel extends MetricOperations {
  public data: MetricModel[];
  public pageNo: number;
  public pageSize: number;
  public hasMore: boolean;
  public constructor(obj) {
    super();
    this.data = obj.data.map((item) => new MetricModel(item));
    this.pageNo = obj.pageNo;
    this.pageSize = obj.pageSize;
    this.hasMore = obj.hasMore;
  }
  public static createMetric(data: any) {
    return new AllPinsModel(data);
  }
}
